import { render, staticRenderFns } from "./OrgSignedStatsByType.vue?vue&type=template&id=373fe470&scoped=true&"
import script from "./OrgSignedStatsByType.vue?vue&type=script&lang=js&"
export * from "./OrgSignedStatsByType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373fe470",
  null
  
)

export default component.exports